import {
  Button,
  Checkbox,
  DraggableWindowHeader,
  TextInput,
} from "@hoylu/client-common";
import React, { type FormEvent, useState } from "react";
import { Localized } from "../../strings";
import { useTextInputLocalization } from "../../utils/useTextInputLocalization";
import Styles from "./ConfirmationDialog.module.css";
import { Modal } from "./Modal";

type ConfirmationDialogProps = {
  icon: string;
  cancelAction: () => void;
  title: string;
  message: string;
  submitAction: (e: FormEvent) => void;
  buttonText: string;
  passwordRequired?: boolean;
  confirmWithCheckmark?: boolean;
  confirmDelete?: string;
};

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  icon,
  cancelAction,
  title,
  message,
  submitAction,
  buttonText,
  passwordRequired = false,
  confirmWithCheckmark = false,
  confirmDelete = "",
}) => {
  const strings = Localized.object("CONFIRMATION_DIALOG");
  const tClose = Localized.object("CLOSE_BUTTON");

  const localizationDict = useTextInputLocalization();

  const [checked, setChecked] = useState(false);
  const toggleChecked = () => {
    setChecked(!checked);
  };

  const buttons = (
    <div className={Styles.footer}>
      {confirmWithCheckmark && (
        <div className={Styles.confirmationCheckbox}>
          <Checkbox checked={checked} onChange={toggleChecked}>
            {confirmDelete}
          </Checkbox>
        </div>
      )}
      <div className={Styles.buttons}>
        <Button onClick={cancelAction} toolTip={strings.CANCEL} type="negative">
          {strings.CANCEL}
        </Button>
        <Button
          disabled={confirmWithCheckmark ? !checked : false}
          formType={passwordRequired ? "submit" : "button"}
          onClick={(e) => !passwordRequired && submitAction(e)}
          toolTip={buttonText}
          type="primary"
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );

  return (
    <Modal>
      <div className={Styles.confirmationDialog}>
        <DraggableWindowHeader
          close={tClose.CLOSE}
          icon={icon}
          onClose={cancelAction}
          title={title}
        />
        <div className={Styles.message}>{message}</div>
        {passwordRequired ? (
          <form className={Styles.form} onSubmit={submitAction}>
            <TextInput
              label={strings.PASSWORD}
              localizationDict={localizationDict}
              name="password"
              type="password"
            />
            {buttons}
          </form>
        ) : (
          buttons
        )}
      </div>
    </Modal>
  );
};
